/**
 * WPA 貨品分類排序：cat_id ASC（對應後端 commerce_collections.external_collection_key）。
 */
export function sortWpaCollections(collections) {
  if (!Array.isArray(collections)) return [];
  return [...collections].sort((a, b) => {
    const catA = String(a?.catId ?? a?.externalCollectionKey ?? '').trim();
    const catB = String(b?.catId ?? b?.externalCollectionKey ?? '').trim();
    return catA.localeCompare(catB, undefined, { numeric: true, sensitivity: 'base' });
  });
}
